import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchAppUserInputEvent } from '@studyportals/inlinesearch-interfaces';
import store from '@/store';

export class UserInputPlugin implements ISubscriber<InlineSearchAppUserInputEvent> {
	public initiate(): void {
		const eventAggregationService = this.getEventAggregationService();
		if (!eventAggregationService) return;

		eventAggregationService.subscribeTo(InlineSearchAppUserInputEvent.EventType, this);
	}

	public notify(event: InlineSearchAppUserInputEvent): void {
		this.handleUserInput(event);
	}

	private handleUserInput(event: InlineSearchAppUserInputEvent): void {
		const { userInput } = event;

		store.mutations.setText(userInput);
	}

	private getEventAggregationService(): IEventAggregationService | undefined {
		return window.EventAggregationService;
	}
}